import { toast } from 'react-toastify';

import { ITraderWallet, useVerifyTraderWalletMutation } from '@entities/trades/wallet';
import { useModal } from '@shared/components/Modal';
import { isApiError } from '@shared/types/fetch-data';

interface IProps<T> {
  wallet: T;
  refetch: () => void;
}

export const ApproveTraderWallet = <T extends ITraderWallet>({ wallet, refetch }: IProps<T>) => {
  const [verifyTraderWallet, { isLoading }] = useVerifyTraderWalletMutation();
  const { closeModal } = useModal();

  const handleConfirm = async () => {
    const result = await verifyTraderWallet(wallet.id);

    if ('data' in result) {
      closeModal();
      refetch();
    }

    if ('error' in result && isApiError(result.error)) {
      toast.error(result.error.data.message);
    }
  };

  return (
    <div className='modal-confirm'>
      <div className='modal-confirm__title'>Approve Wallet</div>
      <div className='modal-confirm__message'>
        Are you sure you want to verify wallet #{wallet.id}? This will mark the wallet as verified.
      </div>
      <div className='modal-confirm__btns'>
        <button disabled={isLoading} className='btn-confirm' onClick={handleConfirm}>
          Approve
        </button>
        <button type='button' className='btn-cancel secondary-btn' onClick={closeModal}>
          Cancel
        </button>
      </div>
    </div>
  );
};
